(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-furniture-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!(section instanceof Element)) return;
      if (section.dataset.furnitureBound === 'true') return;
      section.dataset.furnitureBound = 'true';

      const grid = section.querySelector('[data-furniture-grid]');
      const toggles = section.querySelectorAll('.amyann-grid-toggle');
      const cards = section.querySelectorAll('.amyann-furniture-card');

      toggles.forEach((btn) => {
        btn.addEventListener('click', () => {
          toggles.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (!grid) return;

          const cols = btn.dataset.grid;
          grid.classList.toggle('amyann-furniture-grid--2', cols === '2');
          grid.classList.toggle('amyann-furniture-grid--3', cols === '3');
        });
      });

      cards.forEach((card) => {
        const previewImg = card.querySelector('[data-furniture-preview-image]');
        if (!previewImg) return;

        const swatches = card.querySelectorAll('.amyann-furniture-finish-swatch');
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => {
            if (swatch.classList.contains('is-unavailable')) return;

            const img = swatch.dataset.previewImage;
            if (img) previewImg.src = img;

            swatches.forEach((s) => s.classList.remove('is-active'));
            swatch.classList.add('is-active');
          });
        });
      });
    };

    document.querySelectorAll('.shopify-section .amyann-furniture').forEach((root) => {
      init(root.closest('.shopify-section'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-materials-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!(section instanceof Element)) return;
      if (section.dataset.materialsBound === 'true') return;
      section.dataset.materialsBound = 'true';

      const grid = section.querySelector('[data-materials-grid]');
      const toggles = section.querySelectorAll('.amyann-grid-toggle');
      const modal = section.querySelector('[data-materials-modal]');
      const materialsHeader = section.querySelector('.amyann-materials__header');
      const modalImage = section.querySelector('[data-modal-image]');
      const modalTitle = section.querySelector('[data-modal-title]');
      const modalSubtitle = section.querySelector('[data-modal-subtitle]');
      const modalDescription = section.querySelector('[data-modal-description]');
      const modalAddButton = section.querySelector('[data-modal-add-button]');

      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.toString() && materialsHeader) {
        const stickyHeader = document.querySelector('#custom-header-component');
        const stickyHeaderHeight = stickyHeader instanceof HTMLElement ? stickyHeader.offsetHeight : 0;
        const targetTop = materialsHeader.getBoundingClientRect().top + window.scrollY - stickyHeaderHeight - 16;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'auto' });
      }

      const addToCart = async (variantId, trigger) => {
        if (!variantId) return;
        if (trigger && (trigger.disabled || trigger.dataset.available !== 'true')) return;
        try {
          const addResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });
          if (!addResponse.ok) throw new Error('Failed to add to cart');

          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
          const cart = await cartResponse.json();
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                sourceId: 'materials-collection',
                data: {
                  itemCount: cart.item_count || 0,
                  source: 'materials-collection',
                },
              },
            })
          );
          // Force cart bubbles to exact count to avoid drift from mixed event sources.
          document.querySelectorAll('cart-icon').forEach((icon) => {
            if (typeof icon.renderCartBubble === 'function') {
              icon.renderCartBubble(cart.item_count || 0, false, false);
            }
          });
          if (trigger) {
            trigger.classList.add('is-added');
            setTimeout(() => trigger.classList.remove('is-added'), 1200);
          }
        } catch (e) {
          console.error(e);
        }
      };

      toggles.forEach((btn) => {
        btn.addEventListener('click', () => {
          toggles.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const cols = btn.dataset.grid;
          if (!grid) return;
          grid.classList.toggle('amyann-materials-grid--2', cols === '2');
          grid.classList.toggle('amyann-materials-grid--3', cols === '3');
        });
      });

      section.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const addBtn = target.closest('.js-materials-add');
        if (addBtn && !addBtn.hasAttribute('data-modal-add-button')) {
          addToCart(addBtn.dataset.variantId, addBtn);
          return;
        }

        const openBtn = target.closest('.js-materials-open');
        if (openBtn && modal && modalImage && modalTitle && modalSubtitle && modalDescription && modalAddButton) {
          const img = openBtn.dataset.image || '';
          const title = openBtn.dataset.title || '';
          const subtitle = openBtn.dataset.subtitle || '';
          const description = openBtn.dataset.description || '';
          const variantId = openBtn.dataset.variantId || '';
          const available = openBtn.dataset.available === 'true';

          modalImage.src = img;
          modalImage.alt = title;
          modalTitle.textContent = title;
          modalSubtitle.textContent = subtitle;
          modalDescription.textContent = description;
          modalAddButton.dataset.variantId = variantId;
          modalAddButton.dataset.available = available ? 'true' : 'false';
          modalAddButton.disabled = !available;
          modalAddButton.classList.toggle('is-unavailable', !available);
          if (typeof modal.showModal === 'function') {
            modal.showModal();
          } else {
            modal.setAttribute('open', 'open');
          }
          return;
        }

        if (target.closest('[data-close-modal]') && modal) {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.removeAttribute('open');
          }
        }
      });

      if (modalAddButton) {
        modalAddButton.addEventListener('click', () => {
          addToCart(modalAddButton.dataset.variantId, modalAddButton);
        });
      }

      if (modal) {
        modal.addEventListener('click', (event) => {
          const rect = modal.getBoundingClientRect();
          const outside =
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom;
          if (outside) {
            if (typeof modal.close === 'function') {
              modal.close();
            } else {
              modal.removeAttribute('open');
            }
          }
        });
      }
    };

    document.querySelectorAll('.shopify-section .amyann-materials').forEach((materialsRoot) => {
      init(materialsRoot.closest('.shopify-section'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-membership"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const handleClick = async (button) => {
      if (!button || button.disabled || button.classList.contains('is-loading')) return;
      const variantId = button.dataset.variantId;
      const sellingPlanId = button.dataset.sellingPlanId;
      if (!variantId) return;

      button.classList.add('is-loading');
      const originalLabel = button.textContent;
      button.textContent = 'Adding...';

      const root = window.Shopify?.routes?.root || '/';

      const openCartUI = async () => {
        try {
          const cartResponse = await fetch(`${root}cart.js`);
          const cart = await cartResponse.json();
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                sourceId: 'membership-hero',
                data: { source: 'membership-hero', itemCount: cart.item_count || 0 },
              },
            })
          );
          document.querySelectorAll('cart-icon').forEach((icon) => {
            if (typeof icon.renderCartBubble === 'function') {
              icon.renderCartBubble(cart.item_count || 0, false, false);
            }
          });
        } catch (e) {
          console.error(e);
        }
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location.href = '/cart';
        }
      };

      try {
        const currentCartResponse = await fetch(`${root}cart.js`);
        const currentCart = await currentCartResponse.json();
        const alreadyHasMembership = Array.isArray(currentCart.items)
          && currentCart.items.some((item) => Number(item.variant_id) === Number(variantId));
        if (alreadyHasMembership) {
          await openCartUI();
          return;
        }

        const payload = { id: Number(variantId), quantity: 1 };
        if (sellingPlanId) {
          payload.selling_plan = Number(sellingPlanId);
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!addResponse.ok) {
          let errorPayload = null;
          try {
            errorPayload = await addResponse.json();
          } catch (_) {}
          console.error('cart/add.js error', addResponse.status, errorPayload);

          const description = (errorPayload && (errorPayload.description || errorPayload.message || '')) || '';
          const alreadyInCart = /already in your cart|can only be purchased|limit/i.test(description);

          if (addResponse.status === 422 && alreadyInCart) {
            await openCartUI();
            return;
          }

          throw new Error(description || `Failed to add to cart (${addResponse.status})`);
        }

        await openCartUI();
      } catch (error) {
        console.error(error);
        alert(error.message || 'Sorry, we could not add membership to your cart.');
      } finally {
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-membership-join]');
      if (!button) return;
      event.preventDefault();
      handleClick(button);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!(section instanceof Element)) return;
      if (section.dataset.furnitureBound === 'true') return;
      section.dataset.furnitureBound = 'true';

      const grid = section.querySelector('[data-furniture-grid]');
      const toggles = section.querySelectorAll('.amyann-grid-toggle');

      toggles.forEach((btn) => {
        btn.addEventListener('click', () => {
          toggles.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (!grid) return;
          const cols = btn.dataset.grid;
          grid.classList.toggle('amyann-furniture-grid--2', cols === '2');
          grid.classList.toggle('amyann-furniture-grid--3', cols === '3');
        });
      });

      section.querySelectorAll('.amyann-furniture-card').forEach((card) => {
        const previewImg = card.querySelector('[data-furniture-preview-image]');
        if (!previewImg) return;
        card.querySelectorAll('.amyann-furniture-finish-swatch').forEach((swatch) => {
          swatch.addEventListener('click', () => {
            if (swatch.classList.contains('is-unavailable')) return;
            const img = swatch.dataset.previewImage;
            if (img) previewImg.src = img;
            card.querySelectorAll('.amyann-furniture-finish-swatch').forEach((s) => s.classList.remove('is-active'));
            swatch.classList.add('is-active');
          });
        });
      });
    };

    document.querySelectorAll('.shopify-section .amyann-furniture').forEach((root) => {
      init(root.closest('.shopify-section'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
